import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import * as VideosActions from './videos.actions';
import { VideoService } from '../../core/services/video.service';

@Injectable()
export class VideosEffects {
  private actions$ = inject(Actions);
  private videoService = inject(VideoService);

  loadVideosByLeader$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideosActions.loadVideosByLeader),
      switchMap(({ leaderId }) =>
        this.videoService.getVideosByLeaderId(leaderId).pipe(
          map(videos => VideosActions.loadVideosByLeaderSuccess({ leaderId, videos })),
          catchError(err => of(VideosActions.loadVideosByLeaderFailure({
            error: err?.message ?? 'Failed to load videos'
          })))
        )
      )
    )
  );

  updateProgress$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VideosActions.updateVideoProgress),
      switchMap(async ({ videoId, currentTime, duration, userId }) => {
        const percentage = duration > 0 ? (currentTime / duration) * 100 : 0;
        await this.videoService.updateVideoProgress(userId, videoId, currentTime, duration);
        return VideosActions.updateVideoProgressSuccess({ videoId, currentTime });
      })
    )
  );
}
